import React from "react";
import { Card, CardContent, Grid, ButtonBase, Typography } from "@mui/material";

const TiltAngleCard = ({ tiltAngle, onTiltAngleChange }) => {
  const handleOptionClick = (value) => {
    onTiltAngleChange(value); // Update the tiltAngle when an option is selected
  };

  const tiltOptions = [0, 30, 45, 60, 90]; // Only tilt angles now

  return (
    <Card
      sx={{
        backgroundColor: "#28293e",
        mb: 3,
        px: { xs: 1.5, sm: 4 },
        py: { xs: 2, sm: 5 },
        width: "80%",
      }}
    >
      <CardContent>
        <Typography
          variant="h6"
          gutterBottom
          sx={{ fontSize: { xs: "0.9rem", sm: "1.1rem" } }}
        >
          Select Tilt Angle Option
        </Typography>
        <Grid container spacing={2}>
          {tiltOptions.map((angle, idx) => (
            <Grid item xs={12} sm={6} md={4} key={idx}>
              <ButtonBase
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  p: { xs: 2, sm: 3 },
                  width: "100%",
                  height: "100px",
                  backgroundColor: tiltAngle === angle ? "#34344a" : "#1c1c28", // Highlight selected option
                  borderRadius: "8px",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                  "&:hover": {
                    backgroundColor:
                      tiltAngle === angle ? "#3d3e52" : "#34344a",
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.3)",
                  },
                }}
                onClick={() => handleOptionClick(angle)}
              >
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: "bold",
                    fontSize: { xs: "1.5rem", sm: "2rem" },
                    color: "white",
                  }}
                >
                  {angle}°
                </Typography>
              </ButtonBase>
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default TiltAngleCard;
